export default "__VITE_ASSET__Bnkdl308__"